import * as Styled from './styles'

export default function Button({ children }) {
  return <Styled.Button>{children}</Styled.Button>
}
